import type { Point } from './toPortInfo.tsx';
import type { ViewBoxRect } from './ListEdgeDetails.tsx';

export type ContentBounds = {
	x: number;
	y: number;
	width: number;
	height: number;
};

export const clampPan = (
	pan: Point,
	contentBounds: ContentBounds | undefined,
	viewBox: ViewBoxRect,
	marginFactor = 0.25,
): Point => {
	if (!contentBounds) {
		return pan;
	}

	const marginX = viewBox.width * marginFactor;
	const marginY = viewBox.height * marginFactor;

	const minX = contentBounds.x - marginX;
	const maxX = contentBounds.x + contentBounds.width + marginX;
	const minY = contentBounds.y - marginY;
	const maxY = contentBounds.y + contentBounds.height + marginY;

	return {
		x: Math.max(minX, Math.min(maxX, pan.x)),
		y: Math.max(minY, Math.min(maxY, pan.y)),
	};
};
